/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'slots-on-site': {
    width: 8,
    height: 10,
    viewBox: '0 0 8 10',
    data: '<path pid="0" d="M4 .4C2.17.4.7 1.747.7 3.425.7 5.102 4 9.2 4 9.2s3.3-4.098 3.3-5.775C7.3 1.747 5.83.4 4 .4zm0 4.4c-.84 0-1.5-.605-1.5-1.375S3.16 2.049 4 2.049s1.5.605 1.5 1.376C5.5 4.195 4.84 4.8 4 4.8z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
